import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Link, useLocation } from "react-router-dom";
import {
    FaBeer, FaFacebookF, FaInstagram, FaTwitter, FaSearch,
    FaEnvelopeOpen, FaHammer, FaToggleOn, FaThList, FaPhone
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import './HeaderScreen.css'
import {
    requestApi, RequestModel, ResponseModel,
    EndPointPaths, AssetConstants, printConsole,
    RouteConstants, SessionKeys, clientConfig,
    i18n, strings
} from '../../utils/CommonImports';
import { Customers } from '../../appojo/models/Customers';
import { CustomerLoginRequest } from '../../appojo/requestmodel/CustomerLoginRequest';
import { CustomerLoginResponse } from '../../appojo/responsemodel/CustomerLoginResponse';

const HeaderScreen = (props: any) => {
    let navigate = useNavigate();
    const [stateValue, setStateValue] = useState({
        languageName: '',
        users: new Customers(),
    });
    const [showLoader, setShowLoader] = useState(false);
    const [isConnected, setIsConnected] = useState(true);
    const [initialState, setInitialState] = useState(true);
    const [dummyData, setDummyData] = useState(true);
    const [mobileNumber, setMobileNumber] = useState('');
    const [password, setPassword] = useState('');


    useEffect(() => {
        getSessionValues()
            .then((user) => {
                console.log('moti check : ' + strings('developedby'))
                setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                }, 0)
            });

        return () => {

        }
    }, [props]);

    const getSessionValues = async () => {
        let users = JSON.parse(sessionStorage.getItem(SessionKeys.loginObj));
        let language = sessionStorage.getItem(SessionKeys.languageName);
        if (language == null) {
            language = clientConfig.defaultLanguage;
        }

        i18n.changeLanguage(language);
        stateValue.languageName = language;
        stateValue.users = users;
        setStateValue(stateValue);
        return users;
    }

    const openPopup = () => {
        document.getElementById("loginForm").style.display = "block";
    }
    const closePopup = () => {
        document.getElementById("loginForm").style.display = "none";
    }
    const saveStorage = async (value: any, key: any, type: any) => {
        if (type === "object") {
            sessionStorage.setItem(key, JSON.stringify(value));
        } else if (type === "remove") {
            sessionStorage.removeItem(key);
        } else {
            sessionStorage.setItem(key, value)
        }
    }
    const navigateToPage = (pageName: string) => {
        closePopup();
        if (pageName === 'home') {
            navigate("../");

        } else if (pageName === 'cloth') {
            navigate("../clothscreen");

        }
    }
    const updateRegisterText = (key: string, value: any) => {
        if (key === 'emailmobile') {
            setMobileNumber(value);
        } else if (key === 'password') {
            setPassword(value);
        }
        // printConsole("obj: "+JSON.stringify(kycObject))
        setDummyData(!dummyData)
    }

    const login = async () => {
        if (mobileNumber.length > 5) {
            if (password.length > 5) {
                try {
                    setShowLoader(true);
                    const request = new RequestModel();
                    const loginRequest = new CustomerLoginRequest();
                    loginRequest.userId = mobileNumber;
                    loginRequest.password = password;
                    request.reqObject = loginRequest;
                    const responseResult = await requestApi(request, EndPointPaths.customerlogin, isConnected);
                    if (responseResult.status === 0) {
                        const responsemodel: ResponseModel = responseResult.data;
                        if (responsemodel.statusCode === 0) {
                            toast(strings(responsemodel.message));
                            const loginResponse: CustomerLoginResponse = responsemodel.respObject;
                            const customerObj: Customers = loginResponse.customerObj;
                            saveStorage(customerObj, SessionKeys.loginObj, 'object');
                            navigateToPage('home');
                        } else if (responsemodel.statusCode === 1) {
                            toast(strings(responsemodel.message));
                        } else if (responsemodel.statusCode === 2) {
                            toast(strings(responsemodel.message));
                        } else if (responsemodel.statusCode === 10) {
                            toast(strings(responsemodel.message));
                        } else {
                            toast(strings('plsetry'));
                        }
                    } else if (responseResult.status == 1) {
                        printConsole("API Error location: " + responseResult.data)
                    } else if (responseResult.status == 2) {
                        toast(strings('plsetry'));
                    } else {
                        toast(strings('plsetry'));
                    }
                } catch (err) {
                    printConsole("Try Error: " + err);
                    toast(strings('plsetry'));
                } finally {
                    setShowLoader(false);
                }
            } else {
                toast(strings('enterpassword'));
            }
        } else {
            toast(strings('entermobile'));
        }
    }
    return (
        <>
            {/* sticky_header */}
            <section className='stickySection' >
                <div className='container'>
                    <div className='row'>
                        {/* Sticky_Data */}
                        <div className='col-sm-7 col-7'>
                            <div className='stickyData'>
                                <div className='number fa fa-phone'>&nbsp;9966300046</div>
                                <div className='stickyInfo fa fa-envelope'>&nbsp;support@eseticket.com</div>
                            </div>
                        </div>
                        {/* Sticky_Data_End */}

                        {/* Social_Media */}
                        <div className='col-sm-5 col-5'>
                            <div className='stickyMedia'>
                                <div className='socialIocn fa fa-facebook'>&nbsp;</div>
                                <div className='socialIocn fa fa-instagram' >&nbsp;</div>
                                <div className='socialIocn fa fa-twitter' >&nbsp;</div>
                                {/* <div className='socialIocn fa fa-search' >&nbsp;</div> */}
                            </div>
                        </div>
                        {/* Social_Media_End */}
                    </div>
                </div>
            </section>
            {/* sticky_header_End */}


            {/* header_End */}
            <section className='header_section sticky-top'>
                <nav className="navbar navbar-expand-lg navbar-light  navbar-default">
                    <div className="container">
                        {/* navbar_logo */}
                        <div>
                            <a onClick={() => navigateToPage('home')} className="navbar-brand" >
                                <img alt="ziksam" className='navBarImage' src={AssetConstants.logo} />
                                {/* ESEticket */}
                            </a>
                        </div>
                        {/* navbar_logo_end */}
                        
                        {/* navbar_menu_button */}
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className='toggler fa fa-bars'></span>
                        </button>
                        {/* navbar_menu_button_end */}
                        
                        {/* navbar_link */}
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav  mb-2 mb-lg-0">
                                <li style={{ cursor: 'pointer' }} className="nav-item"><a className="nav-link nav_data" onClick={() => navigateToPage('cloth')} >Clothing</a></li>
                                <li style={{ cursor: 'pointer' }} onClick={openPopup} id="myBtn" className="nav-item"><a className="nav-link sign_data" aria-current="page" >Sign In</a></li>
                            </ul>
                        </div>
                       
                        {/* navbar_link_end */}
                    </div>
                </nav>
            </section>
            {/* header_End */}

            <section style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                <div id="loginForm" className="modal">
                    <div className="modalContent">

                        <div style={{ height: '100vh', width: '100vw', backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                            <div className='loginBox' style={{ height: 'auto', width: '50%', backgroundColor: 'white' }}>

                                <div className='row'>

                                    <div  className='col-sm-6 loginImage' style={{ height: '500px' }}>
                                        <img style={{ height: '100%', width: '100%' }} src='https://cordmagazine.com/wp-content/uploads/2017/07/Top-10-Best-Selling-Clothing-Brands-In-The-World-sajt.jpg' />
                                    </div>
                                    <div className='col-sm-12 pt-5 col-lg-6 ' >
                                        <div className='mt-2' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'auto' }}>
                                            <div style={{ width: "90%" }}>
                                                <div>
                                                    <h4 style={{ textAlign: 'center' }}>Sign In</h4>
                                                </div>
                                                <div style={{ backgroundColor: 'transparent' }} className='mt-3'>
                                                    <form style={{ backgroundColor: 'transparent', width: '100%' }}>
                                                        <input type="text" className='mt-3' style={{ width: '100%', padding: '8px 15px', border: '1px solid #d4d5d9', color: '#ccc', fontSize: '14px' }}
                                                            placeholder='Enter Mobile Number/Email'
                                                            value={mobileNumber}
                                                            onChange={e => updateRegisterText('emailmobile', e.target.value)} />
                                                        <input type="password" className='mt-3' style={{ width: '100%', padding: '8px 15px', border: '1px solid #d4d5d9', color: '#ccc', fontSize: '14px' }}
                                                            placeholder='Enter Password' value={password}
                                                            onChange={e => updateRegisterText('password', e.target.value)} />

                                                    </form>
                                                </div>

                                                <div className='mt-3'>
                                                    <button className='loginBtn' onClick={() => login()}>
                                                        Login
                                                    </button>
                                                </div>
                                                <div className='mt-3' >
                                                    <h6 className='text-center'>or</h6>
                                                </div>
                                                <div className='mt-3'>
                                                    <button className='loginBtn'> Request OTP</button>
                                                </div>
                                                <div className='mt-3'>
                                                    <button className='loginBtn'>
                                                        Sign up
                                                    </button>
                                                </div>
                                                <div className='mt-5 pb-2 text-center' >
                                                    <button onClick={closePopup} className='closeForm close'>
                                                        Close Form
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div style={{ height: '500px', width: '50%', backgroundColor: 'white' }}>

                                <div className='row'>
                                    <div className='col-sm-6' style={{ height: '500px' }}>
                                        <img style={{ height: '100%', width: '100%' }} src='https://i.pinimg.com/originals/26/1c/b4/261cb41d726bd83f6e8ebd750ccc0fbb.jpg' />
                                    </div>
                                    <div className='col-sm-6 pt-5' >
                                        <div className='mt-2' style={{ display: 'flex', justifyContent: 'center',alignItems:'center',height:'350px' }}>
                                            <div style={{ width: "90%" }}>
                                                <div>
                                                    <h4 style={{ textAlign: 'center' }}>Create an account</h4>
                                                </div>
                                                <div style={{ backgroundColor: 'transparent' }} >
                                                    <form style={{ backgroundColor: 'transparent', width: '100%' }} className='mt-3'>
                                                        <input style={{ width: '100%', padding: '8px 15px', border: '1px solid #d4d5d9', color: '#ccc', fontSize: '14px' }} placeholder='Enter Name' />
                                                    </form>
                                                    <form style={{ backgroundColor: 'transparent', width: '100%' }} className='mt-3'>
                                                        <input style={{ width: '100%', padding: '8px 15px', border: '1px solid #d4d5d9', color: '#ccc', fontSize: '14px' }} placeholder='Enter Email' />
                                                    </form>
                                                    <form style={{ backgroundColor: 'transparent' }} className='mt-3'>
                                                        <input style={{ width: '100%', padding: '8px 15px', border: '1px solid #d4d5d9', color: '#ccc', fontSize: '14px' }} placeholder='Enter Password' />
                                                    </form>
                                                </div>
                                                <div className='mt-3'>
                                                    <button className='loginBtn'>
                                                        Sign up
                                                    </button>
                                                </div>
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* ================sign_up================ */}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default HeaderScreen;

{/* <span onClick={closePopup} className="close">&times;</span> */ }
